enum SelfRegisterLoginMode {
    MiProAndNhs = 0,
    MiPro,
    Nhs
}

const DefaultSelfRegisterPatientWelcomeTitle = "Welcome to ORB";

const DefaultSelfRegisterPatientWelcomeSubtitles: { [key: number]: string } = {};
DefaultSelfRegisterPatientWelcomeSubtitles[SelfRegisterLoginMode.MiProAndNhs] = "Please login/register to continue.";
DefaultSelfRegisterPatientWelcomeSubtitles[SelfRegisterLoginMode.MiPro] = "Please login/register to continue.";
DefaultSelfRegisterPatientWelcomeSubtitles[SelfRegisterLoginMode.Nhs] = "Please login/register with your NHS account to continue.";

export { SelfRegisterLoginMode, DefaultSelfRegisterPatientWelcomeTitle, DefaultSelfRegisterPatientWelcomeSubtitles };